export const PASSWORD_STATUS = {
  OK: 'OK',
  EXPIRING_SOON: 'EXPIRING_SOON',
  EXPIRED: 'EXPIRED',
  MUST_CHANGE: 'MUST_CHANGE',
};
